import { AirDatepicker } from './air-datepicker'
import { DatepickerOptions } from './air-datepicker.types'
import { InputType } from '../air-input/air-input.types'

enum DatepickerPlaceholder {
  Date = 'MM-DD-YYYY',
  Year = 'YYYY',
}

export interface DatepickerStrategy {
  getType: () => InputType
  getPlaceholder: () => string
  getValue: (date: Date) => string
  getDatepickerOptions: () => DatepickerOptions
  getDate(value: string): Date | undefined
}

export class DatepickerContext {
  private strategy: DatepickerStrategy

  constructor(private readonly datepicker: AirDatepicker) {
    this.strategy =
      this.datepicker.mode === 'year' ? new DatepickerYearStrategy() : new DatepickerDateStrategy()
  }

  getStrategy(): DatepickerStrategy {
    return this.strategy
  }
}

export class DatepickerDateStrategy implements DatepickerStrategy {
  getType(): InputType {
    return 'date'
  }

  getPlaceholder(): string {
    return DatepickerPlaceholder.Date
  }

  getValue(date: Date): string {
    if (date === undefined) return ''
    return date
      .toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(/\//g, '-')
  }

  getDatepickerOptions(): DatepickerOptions {
    return {
      daysOfWeekDisabled: [0, 6],
      todayHighlight: true,
    }
  }

  getDate(value: string): Date {
    const dayMonthYear: number[] = value.split('-').map((item: string) => Number(item))
    const date = new Date()
    date.setFullYear(dayMonthYear[2], dayMonthYear[0] - 1, dayMonthYear[1])
    return date
  }
}

export class DatepickerYearStrategy implements DatepickerStrategy {
  getType(): InputType {
    return 'date-year'
  }

  getPlaceholder(): string {
    return DatepickerPlaceholder.Year
  }

  getValue(date: Date): string {
    if (date === undefined) return ''
    return date.getFullYear().toString()
  }

  getDatepickerOptions(): DatepickerOptions {
    return {
      todayHighlight: true,
      pickLevel: 2,
    }
  }

  getDate(value: string): Date {
    const date = new Date()
    date.setFullYear(Number(value))

    return date
  }
}
